import "../../styles/components/_breadcrumbs.scss";
import { csqTrackDynamicVariable, csqTrackPageEvent, emitShopifyEvent } from "../services/analytics.service";
console.log("product template loaded");
// Fabric module segmentation — only fires when the section renders (i.e. product has a fabric metafield).
// The fabric name is read from the DOM rather than the dataLayer to avoid jQuery timing dependencies.
// @see product-primary-fabric.liquid, analytics.service.ts
const fabricContainer = document.querySelector('.product-primary-fabric__container');
if (fabricContainer) {
    const fabricName = fabricContainer.dataset.fabricName;
    csqTrackPageEvent('fabric_module_present');
    if (fabricName) {
        csqTrackDynamicVariable('primary_fabric', fabricName);
    }
}
// Product department segmentation (e.g. "Mens", "Womens").
// window.productDepartment is set synchronously by product-main.liquid before any module code runs,
// so it is reliably available here without a timing guard.
if (window.productDepartment) {
    csqTrackDynamicVariable('product_department', window.productDepartment);
}
if (window.productCompareAtPrice !== undefined) {
    csqTrackDynamicVariable('product_is_markdown', window.productCompareAtPrice > 0 ? 'yes' : 'no');
}
const productType = window.segmentLayer?.product?.category;
if (productType) {
    csqTrackDynamicVariable('product_type', productType);
}
setupReviewsViewTracking(document.querySelector(`.product__review-container > .yotpo-widget-instance`));
function setupReviewsViewTracking(widget) {
    if (!widget) {
        console.warn("yotpo reviews widget not found; unable to setup tracking");
        return;
    }
    const startIntersectionTracking = () => {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                emitShopifyEvent("untuckit:product_reviews_viewed");
                observer.disconnect();
            }
        }, {
            threshold: [0.3]
        });
        intersectionObserver.observe(widget);
    };
    // Yotpo injects .yotpo-main-reviews-widget before async content renders, so the
    // element often has height: 0 at first. IntersectionObserver can't reach a 0.3
    // ratio against a zero-area box — wait for layout before observing visibility.
    if (widget.getBoundingClientRect().height > 0) {
        startIntersectionTracking();
        return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
        if (entries[0].contentRect.height > 0) {
            resizeObserver.disconnect();
            startIntersectionTracking();
        }
    });
    resizeObserver.observe(widget);
}
